class VariantSectionRefresh extends HTMLElement {
  constructor() {
    super();
    this.handle = this.getAttribute('data-product-handle');
    this.sectionId = this.getAttribute('data-section-id');
    this.blockId = this.getAttribute('data-block-id');
    this.isAllowed = this.getAttribute('data-is-allowed') === 'true';
    this.previousLoadingId = null;

    if (this.isAllowed) {
      document.addEventListener('onVariantChange', this.onVariantChange.bind(this));
    }
  }

  onVariantChange(e) {
    this.refreshContent(e.detail.currentVariant.id);
  }

  refreshContent(variantId) {
    if (this.previousLoadingId === variantId) return;

    this.abortController?.abort('new version loading');
    this.abortController = new AbortController();

    this.previousLoadingId = variantId;
    this.dispatchCustomEvent('loading');

    const endpoint = `/products/${this.handle}?section_id=${this.sectionId}&variant=${variantId}`;
    fetch(endpoint, { signal: this.abortController.signal })
      .then((e) => e.text())
      .then((e) => {
        const section = new DOMParser()
          .parseFromString(e, 'text/html')
          .querySelector(this.blockId ? `#${this.blockId}` : '.shopify-section');
               if (!section) {
          console.error(`VariantSectionRefresh: element not found (blockId: ${this.blockId}, sectionId: ${this.sectionId})`);
          return;
        }
        this.renderSection(section);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  renderSection(section) {
    if (section.querySelector('variant-section-refresh')) {
      this.innerHTML = section.querySelector('variant-section-refresh').innerHTML;
    } else {
      this.innerHTML = section.outerHTML;
    }
    this.dispatchCustomEvent('render');
    this.dispatchCustomEvent('', 'pp-some-section-refresh');
  }

  dispatchCustomEvent(eventName, fullEventName) {
    document.dispatchEvent(
      new CustomEvent(fullEventName || `${this.sectionId}:${eventName}`, {
        detail: {
          sectionId: this.sectionId,
        },
      })
    );
  }
}

customElements.define('variant-section-refresh', VariantSectionRefresh);
